<template>
  <div class="container mx-auto p-4">
    <div class="mb-6">
      <button
        @click="goBack"
        class="flex items-center px-4 py-2 bg-orange-400 text-white rounded hover:bg-orange-500 transition-colors"
      >
        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
        </svg>
        Back to Manuals
      </button>
    </div>

    <div v-if="manual" class="bg-white rounded-lg shadow-md p-6">
      <div class="mb-6">
        <h1 class="text-2xl font-bold text-gray-800">{{ manual.title }}</h1>
        <p class="text-gray-600 mt-2">{{ manual.description }}</p>
        <div class="flex items-center text-sm text-gray-500 mt-2">
          <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
          </svg>
          {{ formatDate(manual.created_at) }}
        </div>
      </div>

      <div class="border rounded-lg overflow-hidden">
        <iframe
          v-if="manual.file_url"
          :src="manual.file_url"
          class="w-full h-screen border-0"
          allowfullscreen
        ></iframe>
        <div v-else class="flex items-center justify-center h-96 text-gray-500">
          <div class="text-center">
            <svg class="w-16 h-16 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
            </svg>
            <p>No document available for preview.</p>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex items-center justify-center h-96">
      <div class="text-center">
        <svg class="w-16 h-16 mx-auto mb-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
        </svg>
        <p class="text-gray-500">Manual not found.</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: "ManualViewer",
  data() {
    return {
      manual: null,
    };
  },
  async created() {
    const manualId = this.$route.params.id;
    if (manualId) {
      await this.fetchManual(manualId);
    }
  },
  methods: {
    async fetchManual(id) {
      try {
        const response = await api.getManual(id);
        this.manual = response.data || response;
      } catch (error) {
        console.error('Error fetching manual:', error);
        // Fallback to mock data if API fails
        this.manual = {
          id: parseInt(id),
          title: "Sample Manual",
          description: "This is a sample manual for demonstration purposes.",
          file_url: "https://example.com/sample-manual.pptx",
          created_at: "2024-01-15T10:00:00Z"
        };
      }
    },
    goBack() {
      this.$router.push({ name: 'ManualsPage' });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
  }
};
</script>

<style scoped>
/* Additional styles if needed */
</style>